// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { getDryEyeProfiles } from "../../../api";
import { DryEyeProfileType } from "../../../types";

export const useDryEyeProfiles = (clinicId: string | undefined) => {
  const { getToken } = useTokenAccess();

  return useQuery<Array<DryEyeProfileType>>({
    queryKey: ["dry-eye-profiles", clinicId],
    queryFn: async () => {
      if (!clinicId) throw new Error();

      const token = await getToken();
      return getDryEyeProfiles(token, clinicId);
    },
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // optional: cache for 5 minutes
  });
};
